import {
    POS_SUCCESS,
    POS_LOADING,
  } from '../actions/POSAction';
  
  const initialState = {
    posData: [],
    isLoading: true
  };
  
  const POSReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case POS_SUCCESS:
        return { ...state, posData: action.data, isLoading: false };
      case POS_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default POSReducer;
  